import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import LazyLoad from 'react-lazyload'

import s from './Gsixth.module.scss'
import Png3 from '../common/3-1.png'
import Png32 from '../common/3-2.png'

class Gsixth extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      // 初始state
      index: 0,
      opacity: 1,
      showAnimation: false
    }
    this._handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll)
    // 初始检查一次位置
    this._handleScroll()
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll)
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight
    const gsixthRect = this.refs.Gsixth.getBoundingClientRect()
    
    // 当元素的顶部进入视口60%时触发动画
    if (gsixthRect.top < clientHeight * 0.6 && !this.state.showAnimation) {
      this.setState({ showAnimation: true })
    }
  }
  render() {
    const { showAnimation } = this.state
    
    return (
      <div ref="Gsixth">
        <LazyLoad height={500}>
          <div className={s.Gsixth}>
            <div className={s.warp}>
              <div className={s.img} ref="img" />
              <div className={`${s.title} ${showAnimation ? s.animateIn : s.hidden}`} ref="title">
                <FormattedMessage id="gs3_three_title" values={{br: <br/>}} className={s.title_t}/>
                <div className={s.bottom}>

                  <div className={s.bottom_item}>
                    <img src={Png3} alt="" className={s.item_icon}/>
                    <FormattedMessage id="gs3_three_desc1" values={{br: <br/>}} className={s.item_name}/>
                  </div>

                  <div className={s.bottom_item}>
                    <img src={Png32} alt="" className={s.item_icon}/>
                    <FormattedMessage id="gs3_three_desc2" values={{br: <br/>}} className={s.item_name}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
      </div>
    )
  }
}

export default Gsixth
